import {useState, useEffect} from "react";
import {useLocation, Link} from "react-router-dom";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Avatar from "@mui/material/Avatar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import properties from "constants/ApplicationConstants";
import {useMaterialUIController, setTransparentNavbar, setMiniSidenav} from "context";
import bntLogo from "../../../assets/images/BNtlogo.png";
import {navbar, navbarContainer, navbarMobileMenu} from "./styles";

function DashboardNavbar({absolute, light, isMini}) {
  const [controller, dispatch] = useMaterialUIController();
  const {fixedNavbar} = controller;
  const [photoBase64, setPhotoBase64] = useState(
    window.sessionStorage.getItem("photoBase64") || ""
  );

  useEffect(() => {
    if (fixedNavbar) {
      setTransparentNavbar(dispatch, false);
    }

    const handlePhotoUpdate = () => {
      const newPhotoBase64 = window.sessionStorage.getItem("photoBase64") || "";
      setPhotoBase64(newPhotoBase64);
    };

    window.addEventListener("photoBase64Updated", handlePhotoUpdate);

    return () => {
      window.removeEventListener("photoBase64Updated", handlePhotoUpdate);
    };
  }, [dispatch, fixedNavbar]);

  const userType = JSON.parse(localStorage.getItem("userType"));
  let username = window.sessionStorage.getItem("username");
  username = username?.replace(/^"(.*)"$/, "$1");
  const empName = window.sessionStorage.getItem("EmpName");
  const currentDesignation = window.sessionStorage.getItem("currentDesignation");

  let welcomeText = "Welcome,";
  const formatName = email => {
    const namePart = email.split("@")[0];
    const parts = namePart.split(/[\._]/);
    return parts.map(part => part.charAt(0).toUpperCase() + part.slice(1)).join(" ");
  };

  if (userType === "Admin") {
    welcomeText = "Welcome, Admin";
  } else if (username) {
    const firstName = formatName(username);
    welcomeText = `Welcome, ${empName || firstName || "User"}`;
  }

  // ✅ Dispatch custom event so Sidenav knows user intentionally opened sidebar
  const handleSidebarOpen = () => {
    window.dispatchEvent(new CustomEvent("userOpenedSidenav"));
    setMiniSidenav(dispatch, false);
  };

  return (
    <>
      <AppBar
        position="fixed"
        color="inherit"
        sx={theme => ({
          ...navbar(theme, {}),
          width: "100%",
          left: 0,
          height: "64px"
        })}
      >
        <Toolbar
          sx={{
            ...navbarContainer,
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            padding: 0,
            margin: 0,
            left: 0,
            minHeight: "64px",
            height: "64px",
            position: "relative"
          }}
        >
          {/* Burger menu — mobile only */}
          <MDBox
            display={{xs: "flex", xl: "none"}}
            alignItems="center"
            sx={{position: "absolute", left: 10, zIndex: 3, height: "64px"}}
          >
            <IconButton
              onClick={handleSidebarOpen}
              sx={navbarMobileMenu()}
              edge="start"
              aria-label="open sidebar"
            >
              <MenuIcon />
            </IconButton>
          </MDBox>

          {/* Logo */}
          <MDBox
            display="flex"
            alignItems="center"
            sx={{
              position: "absolute",
              left: {xs: 50, sm: 8, md: 75},
              width: {xs: "150px", sm: "180px", md: "200px"},
              height: "64px",
              justifyContent: "flex-start",
              zIndex: 2
            }}
          >
            <img
              src={bntLogo}
              alt="BNT Logo"
              style={{
                height: "36px",
                maxWidth: "100%",
                objectFit: "contain"
              }}
            />
          </MDBox>

          {/* Right side — Avatar + Welcome text */}
          <MDBox
            display="flex"
            alignItems="center"
            gap={1.5}
            sx={{
              marginLeft: "auto",
              paddingRight: "24px"
            }}
          >
            <Avatar
              src={photoBase64 ? `data:image/jpeg;base64,${photoBase64}` : ""}
              sx={{
                width: 48,
                height: 48,
                background: "linear-gradient(to bottom, #53B0E0, #2D2EAA)",
                fontSize: "14px"
              }}
            />
            <MDBox>
              <MDTypography
                variant="button"
                fontWeight="medium"
                sx={{
                  color: "#1a202c",
                  fontSize: "14px",
                  lineHeight: 1.2,
                  display: "block",
                  fontFamily: properties.fontFamily
                }}
              >
                {welcomeText}
              </MDTypography>
              {currentDesignation && userType !== "Admin" && (
                <MDTypography
                  variant="caption"
                  sx={{
                    color: properties.colors.Black,
                    fontFamily: properties.fontFamily,
                    fontSize: "12px",
                    display: "block"
                  }}
                >
                  {currentDesignation}
                </MDTypography>
              )}
              <MDTypography
                variant="caption"
                sx={{
                  color: properties.colors.Black,
                  fontFamily: properties.fontFamily,
                  fontSize: "12px",
                  display: "block"
                }}
              >
                {new Date().toLocaleDateString("en-GB", {
                  day: "numeric",
                  month: "long",
                  year: "numeric"
                })}
              </MDTypography>
            </MDBox>
          </MDBox>
        </Toolbar>
      </AppBar>
      <MDBox sx={{height: "64px"}} />
    </>
  );
}

DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false
};

DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool
};

export default DashboardNavbar;